/** Byte count as the short label an attachment chip shows: "209 KB", "1.4 MB". */
export function formatSize(bytes: number): string {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/**
 * Substitute every `{{token}}` the caller has a value for.
 *
 * Resolution happens at SEND time rather than at insert time, so the composer
 * shows the same `{{token}}` the rest of the app does while the reply is being
 * written — and support still receives finished prose instead of a merge tag it
 * would have to decode. A token with no value is left alone: the reporter typed
 * it, and silently deleting their text is worse than showing it through.
 */
export function resolveVariables(body: string, values: Record<string, string>): string {
    return body.replace(
        /\{\{\s*([\w.]+)\s*\}\}/g,
        (match, token: string) => values[token] ?? match,
    );
}
